(function () {
    'use strict';

    angular
        .module('app')
        .controller('SegmentsListController', SegmentsListController);

    SegmentsListController.$inject = ['API', 'alert', 'debug', 'ListViewSearchExtension',];

    function SegmentsListController(API, alert, debug, ListViewSearchExtension) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.searchTerm = '';
        vm.page = 1;
        vm.perPage = 20;
        vm.listMeta = {};
        vm.loadingState = {
            segmentIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.loadResources = loadResources;
        vm.listObject.filter = {};


        activate();

        function activate() {
            loadResources();
        }

        function openRemoveModal() {
            alert.confirm('remove-something');
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
            };

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.Segment.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.Segment.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.segmentIsLoading = true;
                promise.then(function (response) {
                    vm.segments = response.items;
                    debug.log(response);
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                    .finally(function() {
                        vm.loadingState.segmentIsLoading = false;
                    });
            }
        }
    }
})();